// extracted by mini-css-extract-plugin
module.exports = {"fixed-nav":"index-fixed-nav-1rG3u","arrowIcon_dark":"index-arrowIcon_dark-26gXi","arrow":"index-arrow-2gYCc","swiper-preloader-spin":"index-swiper-preloader-spin-3oLH2"};